import { render, staticRenderFns } from "./profile-upload.vue?vue&type=template&id=04c31960&scoped=true"
import script from "./profile-upload.vue?vue&type=script&lang=js"
export * from "./profile-upload.vue?vue&type=script&lang=js"
import style0 from "./profile-upload.vue?vue&type=style&index=0&id=04c31960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c31960",
  null
  
)

export default component.exports